import React, {useEffect, useContext} from "react";
import Row from "@amzn/meridian/row";
import Link from "@amzn/meridian/link";
import Text from "@amzn/meridian/text";
import Icon from "@amzn/meridian/icon"
import exportSmallTokens from "@amzn/meridian-tokens/base/icon/export-small"
import Table, {
    TableRow,
    TableCell,
    TableSectionHeader,
} from "@amzn/meridian/table";
import {LineHaulListContext} from "./context/LineHaulListContext";
import {
    getTime,
    getRegion,
    getRefreshInterval,
    findMiddleColumnNumber,
    findAlignmentForColumn,
    packageSizeColumnValueToRequestValue, findTotalUniqueValuesForPackageSizeColumn, chainWalk
} from "../util/Util";
import {FormattedMessage} from "react-intl";
import {ReceiveGroupByContext} from "../receive/context/ReceiveGroupByContext";
import RefreshTimer from "../util/RefreshTimer";
import {CYCLE, PACKAGE_SIZE, CLUSTER, VOLUME, FMC, FEATURES, ACTION_TYPE} from "../util/Constants";
import Tooltip from "@amzn/meridian/tooltip";
import infoTokens from "@amzn/meridian-tokens/base/icon/info-knockout"
import './Linehaul.css';
import {ConfigContext} from "../global/context/ConfigContext";
import {getFeaturesFromParent} from "../handler/ParentDataHandler";

const LineHauls = (props) => {
    const {viewModel, dispatch} = useContext(LineHaulListContext);
    const { groups } = useContext(ReceiveGroupByContext);
    const {configDispatch, configViewModel} = useContext(ConfigContext);

    const onLineHaulClick = (lineHaul) => {
        let origin = lineHaul.origin ? lineHaul.origin : "-";
        const url = "/linehaulDetail/" + lineHaul.lineHaulId + "/" + origin + "/" +
            (lineHaul.lineHaulTime.actualTime ? lineHaul.lineHaulTime.actualTime : "-") + "/" +
            (lineHaul.lineHaulTime.departedTime ? lineHaul.lineHaulTime.departedTime : "-");
        props.history.push(url)
    }

    const getPackageListUrl = (lineHaul, filterType, filterValue) => {
        if (!filterValue) {
            return "#packageList/" + lineHaul.lineHaulId;
        } else {
            return "#packageList/" + lineHaul.lineHaulId + "/" + filterType + "/" + filterValue;
        }
    };

    const getLocationUrl = (lineHaul) => {
        let region = getRegion();
        switch(region) {
            case "US" :
                return "https://trans-logistics.amazon.com/fmc/map?loadType=VRID&loadId=" + lineHaul.lineHaulId
            case "EU" :
                return "https://trans-logistics-eu.amazon.com/fmc/map?loadType=VRID&loadId=" + lineHaul.lineHaulId
            case "FE" :
                return "https://trans-logistics-fe.amazon.com/fmc/map?loadType=VRID&loadId=" + lineHaul.lineHaulId
            default :
                return "https://trans-logistics.amazon.com/fmc/map?loadType=VRID&loadId=" + lineHaul.lineHaulId
        }
    }

    const getData = (selectedGroup) => {
        getFeatureStatus();
        dispatch({type: 'LOAD_VIEW', data:{groupBy: selectedGroup, dispatcher: dispatch}});
    }

    const getFeatureStatus = () => {
        getFeaturesFromParent([FEATURES.IS_UNLOADING_SEQUENCE_FLOW_ENABLED]).then(featureStatus => {
            configDispatch({type: ACTION_TYPE.GET_FEATURES_STATUS, featureStatus: featureStatus.data});
        });
    }

    const isUnloadingSequenceFlowEnabled = chainWalk(() =>
        configViewModel.featureStatus[FEATURES.IS_UNLOADING_SEQUENCE_FLOW_ENABLED], false);

    const getFMCUrl = (lineHaul) => {
        let region = getRegion()
        switch(region) {
            case "US" :
                return "https://trans-logistics.amazon.com/fmc/execution/search/" + lineHaul.lineHaulId
            case "EU" :
                return "https://trans-logistics-eu.amazon.com/fmc/execution/search/" + lineHaul.lineHaulId
            case "FE" :
                return "https://trans-logistics-fe.amazon.com/fmc/execution/search/" + lineHaul.lineHaulId
            default :
                return "https://trans-logistics.amazon.com/fmc/execution/search/" + lineHaul.lineHaulId
        }
    }

    const getUnloadingSequenceValue = (unloadingSequence) => {
        return unloadingSequence === -1 ? '-' : unloadingSequence
    }

    useEffect(() => {
        getData(groups.selectedGroup.value)
        const interval = setInterval(() => {
            if (!document.hidden) {
                getData(groups.selectedGroup.value)
            }
        }, getRefreshInterval());
        return () => clearInterval(interval);
    }, [groups.selectedGroup.value]);

    const subVolumeColumnsHeadingSet = new Set();
    const findTotalUniqueValuesForSubColumnGeneration = () => {
        if (groups.selectedGroup.value === PACKAGE_SIZE) {
             findTotalUniqueValuesForPackageSizeColumn(subVolumeColumnsHeadingSet);
        } else {
            if (viewModel.arrived.length > 0) {
                viewModel.arrived.forEach(lineHaul =>
                {
                    if (lineHaul.groupedVolume !== null && Object.keys(lineHaul.groupedVolume).length > 0) {
                        Object.keys(lineHaul.groupedVolume).forEach(volume => subVolumeColumnsHeadingSet.add(volume));
                    }
                })}
            if (viewModel.inComing.length > 0)  {
                viewModel.inComing.forEach(lineHaul =>
                {
                    if (lineHaul.groupedVolume !== null && Object.keys(lineHaul.groupedVolume).length > 0)
                        Object.keys(lineHaul.groupedVolume).forEach(volume => subVolumeColumnsHeadingSet.add(volume));
                })}}
    }
    const createVolumeColumnHeading = () => {
        const volumeColumns = [];

        if (groups.selectedGroup.value === PACKAGE_SIZE || groups.selectedGroup.value === CYCLE || groups.selectedGroup.value === CLUSTER) {
            //Finding total column size by finding all unique values in the whole data
            findTotalUniqueValuesForSubColumnGeneration();

            if (subVolumeColumnsHeadingSet.size > 0) {
                //Finding middle column number
                const midColumnNumber = findMiddleColumnNumber(subVolumeColumnsHeadingSet);
                const alignmentForColumn = findAlignmentForColumn(subVolumeColumnsHeadingSet);

                //Creating topmost Volume heading by setting it on the middle column
                Array.from(subVolumeColumnsHeadingSet).forEach((subVolumeColumnsHeadingSetValue, index) =>
                    (volumeColumns.push(index === midColumnNumber ?
                        <TableCell alignmentHorizontal = {alignmentForColumn}>
                            <FormattedMessage id = "linehaul.volume" defaultMessage = {VOLUME}/>
                        </TableCell> : <TableCell/>)))
            }
            else
            {
                // If no data is there, then generating a single 'Volume' column
                volumeColumns.push(
                    <TableCell alignmentHorizontal="center">
                    <FormattedMessage id = "linehaul.volume" defaultMessage = {VOLUME}/>
                </TableCell>)
            }
            volumeColumns.push(
                <TableCell alignmentHorizontal="left">
                <FormattedMessage id = "linehaul.FMC" defaultMessage = {FMC}/>
            </TableCell>)
        }
        else
        {
            //Creating two empty TableCells after "Details" Column Heading
             volumeColumns.push(<TableCell/>);
             volumeColumns.push(<TableCell/>);
        }
        return volumeColumns;
    }


    //Creating sub column headings for the Volume Heading
    const createVolumeColumnSubHeadings = () => {
        if ((groups.selectedGroup.value === PACKAGE_SIZE || groups.selectedGroup.value === CYCLE ||
            groups.selectedGroup.value === CLUSTER) && subVolumeColumnsHeadingSet.size > 0) {
            const volumeSubColumns = [];
            const tooltipTitle =  <FormattedMessage id="tooltip.non_conveyable_description"
                                         defaultMessage="NC: Packages that exceed 42'' in a single dimension"/>

                // Displaying all subVolumeColumnsHeadingSet values as column headings
                Array.from(subVolumeColumnsHeadingSet).forEach((subVolumeColumnsHeadingSetValue) => (
                    volumeSubColumns.push(
                        <TableCell alignmentHorizontal="center">
                            <React.Fragment>
                            <FormattedMessage id = {subVolumeColumnsHeadingSetValue}
                                              defaultMessage = {subVolumeColumnsHeadingSetValue}/>
                            <div  id = "Non_Conveyable_Tooltip"/>
                                {subVolumeColumnsHeadingSetValue === "NC" ?
                                    <Tooltip position="end" title={tooltipTitle}>
                                        <Icon id = "Non_Conveyable_Tooltip" tokens={infoTokens} aria-describedby="NCToolTip"/>
                                    </Tooltip> : ""}
                            </React.Fragment>
                        </TableCell>)))

                return volumeSubColumns;

        } else {
            // Displaying "Volume" Column in case of no sub-headings
            return (
                <TableCell alignmentHorizontal="center">
                <FormattedMessage id="linehaul.volume" defaultMessage = {VOLUME}/>
                </TableCell>);
        }
    }

    const displayDataForVolumeAsConcatenatedString = (lineHaul) => {
            const rowValue = [];
            let groupedVolumeString = '';
            if (lineHaul.groupedVolume !== null) {
                Object.keys(lineHaul.groupedVolume).forEach(key =>
                    groupedVolumeString +=
                        key + "(" + lineHaul.groupedVolume[key] + ")/");
                lineHaul.groupedVolume = groupedVolumeString.substring(0, groupedVolumeString.length-1);
            }
            rowValue.push(
                <TableCell alignmentHorizontal = "center"> {
                    lineHaul.volume === 0 ? '-' :
                        <Link href = {getPackageListUrl(lineHaul)} type = "secondary">
                            {lineHaul.groupedVolume? lineHaul.groupedVolume: lineHaul.volume}
                        </Link>
                }</TableCell>);
            return rowValue;
        }

    const displayDataForVolumeAsIndividualLinks = (lineHaul) => {
        const rowValue = [];

        if (subVolumeColumnsHeadingSet.size > 0) {
            if (lineHaul.groupedVolume !== null && Object.keys(lineHaul.groupedVolume).length > 0) {
                rowValue.push(Array.from(subVolumeColumnsHeadingSet).map((subVolumeColumnsHeadingSetValue) => {
                    const columnValueToBeSentInLink = (groups.selectedGroup.value === PACKAGE_SIZE ?
                        packageSizeColumnValueToRequestValue(subVolumeColumnsHeadingSetValue) : subVolumeColumnsHeadingSetValue);
                    return (
                        <TableCell alignmentHorizontal = "center">
                            <Link href={getPackageListUrl(lineHaul, groups.selectedGroup.value, columnValueToBeSentInLink)} type = "secondary">
                                {
                                    lineHaul.groupedVolume.hasOwnProperty(subVolumeColumnsHeadingSetValue) ? lineHaul.groupedVolume[subVolumeColumnsHeadingSetValue] : '-'
                                }
                            </Link>
                        </TableCell>)
                }))}
            else
            {
                rowValue.push(Array.from(subVolumeColumnsHeadingSet).map(() => {
                    return (<TableCell/>)
                }))
            }} else {
            // If no data is there, then generating an empty table cell
                rowValue.push(<TableCell/>);
        }
        return rowValue;
    }

    //Populating values for Volume column
    const displayDataForVolume = (lineHaul) => {
        let rowValue = [];
        if (groups.selectedGroup.value === PACKAGE_SIZE || groups.selectedGroup.value === CYCLE || groups.selectedGroup.value === CLUSTER) {
            rowValue = displayDataForVolumeAsIndividualLinks(lineHaul)
        } else {
            rowValue = displayDataForVolumeAsConcatenatedString(lineHaul)
        }
        return rowValue;
    }

    return (
        <div>
            <Row widths="100%" alignmentVertical="top">
                <div>
                    <RefreshTimer deps={[viewModel]}/>
                    <br/>
                    <div style={{ overflowX: "auto", width: "100%" }}>
                        <Table headerRows={2} spacing="small"
                               headerColumns={1}
                               fixHeaderRows = {true}
                               fixHeaderRowsFullWidth={true}
                               stickyHeaderColumn={true}>
                            <TableRow>
                                <TableCell alignmentHorizontal = "left">
                                    <FormattedMessage id="linehaul.status" defaultMessage="Status"/>
                                </TableCell>
                                <TableCell />
                                <TableCell alignmentHorizontal = "center">
                                    <FormattedMessage id="linehaul.arrival" defaultMessage="Arrival"/>
                                </TableCell>
                                <TableCell />
                                <TableCell />
                                <TableCell alignmentHorizontal = "center">
                                    <FormattedMessage id="linehaul.details" defaultMessage="Details"/>
                                </TableCell>
                                {createVolumeColumnHeading()}
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <FormattedMessage id="linehaul.vrid" defaultMessage="VRID"/>
                                </TableCell>
                                <TableCell>
                                    <FormattedMessage id="linehaul.origin" defaultMessage="Origin"/>
                                </TableCell>
                                <TableCell>
                                    <FormattedMessage id="linehaul.status" defaultMessage="Status"/>
                                </TableCell>
                                <TableCell>
                                    <FormattedMessage id="linehaul.location" defaultMessage="Location"/>
                                </TableCell>
                                <TableCell alignmentHorizontal = "right">
                                    <FormattedMessage id="linehaul.planned" defaultMessage="Planned"/>
                                </TableCell>
                                <TableCell alignmentHorizontal = "right">
                                    <FormattedMessage id="linehaul.actual" defaultMessage="Actual"/>
                                </TableCell>
                                {createVolumeColumnSubHeadings()}
                                { isUnloadingSequenceFlowEnabled
                                    ? <TableCell>
                                        <FormattedMessage id="linehaul.unloadSequence" defaultMessage = "Unload Sequence"/>
                                    </TableCell> : null
                                }
                                <TableCell>
                                    <FormattedMessage id="linehaul.FMC" defaultMessage = {FMC}/>
                                </TableCell>
                            </TableRow>
                            { viewModel.arrived.length > 0 ?
                                <TableSectionHeader>
                                    <FormattedMessage id="linehaul.arrived" defaultMessage="Arrived"/>
                                </TableSectionHeader>
                                : null }
                            {viewModel.arrived.map(lineHaul => (
                                    <TableRow key={lineHaul.lineHaulId} highlightOnHover={true} onClick={() => {onLineHaulClick(lineHaul)}}>
                                        <TableCell>
                                            <Text type="h100">{lineHaul.lineHaulId}</Text>
                                        </TableCell>
                                        <TableCell>{lineHaul.origin}</TableCell>
                                        <TableCell>
                                            <FormattedMessage id="linehaul.inyard" defaultMessage="In Yard"/>
                                        </TableCell>
                                        <TableCell>
                                            {lineHaul.targetDockDoor !== null ? lineHaul.targetDockDoor : "-"}
                                        </TableCell>
                                        <TableCell alignmentHorizontal = "right">{getTime(lineHaul.lineHaulTime.plannedTime)}</TableCell>
                                        <TableCell alignmentHorizontal = "right">
                                            {(lineHaul.lineHaulTime.actualTime === null || lineHaul.lineHaulTime.actualTime === '') ?
                                                (lineHaul.lineHaulTime.gpsTime === null || lineHaul.lineHaulTime.gpsTime === '') ? ''
                                                    : getTime(lineHaul.lineHaulTime.gpsTime)
                                                : getTime(lineHaul.lineHaulTime.actualTime)}
                                        </TableCell>
                                        {displayDataForVolume(lineHaul)}
                                        { isUnloadingSequenceFlowEnabled
                                            ? <TableCell> {getUnloadingSequenceValue(lineHaul.unloadingSequence)} </TableCell>
                                            : null
                                        }
                                        <TableCell>
                                            <Link href = {getFMCUrl(lineHaul)} type="secondary" target="_blank" rel="noreferrer noopener">
                                                View <Icon tokens={exportSmallTokens} />
                                            </Link>
                                        </TableCell>
                                    </TableRow>
                                )
                            )}
                            { viewModel.inComing.length > 0 ?
                                <TableSectionHeader>
                                    <FormattedMessage id="linehaul.incoming" defaultMessage="Incoming"/>
                                </TableSectionHeader>
                                : null }
                            {viewModel.inComing.map(lineHaul => (
                                    <TableRow key={lineHaul.lineHaulId} highlightOnHover={true} onClick={() => {onLineHaulClick(lineHaul)}}>
                                        <TableCell>
                                            <Text type="h100">{lineHaul.lineHaulId}</Text>
                                        </TableCell>
                                        <TableCell>{lineHaul.origin ? lineHaul.origin : '-'}</TableCell>
                                        <TableCell>{lineHaul.lineHaulStatus}</TableCell>
                                        <TableCell>
                                            {lineHaul.targetDockDoor !== null ? lineHaul.targetDockDoor :
                                                <Link href={getLocationUrl(lineHaul)} type="secondary" target="_blank" rel="noreferrer noopener">
                                                    View <Icon tokens={exportSmallTokens} />
                                                </Link>
                                            }
                                        </TableCell>
                                        <TableCell alignmentHorizontal = "right">
                                            {getTime(lineHaul.lineHaulTime.plannedTime)}
                                        </TableCell>
                                        <TableCell alignmentHorizontal = "right">
                                            {lineHaul.lineHaulTime.gpsTime === null ?
                                                (lineHaul.lineHaulTime.actualTime === null || lineHaul.lineHaulTime.actualTime === '') ? ''
                                                    : ("Exp " + getTime(lineHaul.lineHaulTime.actualTime))
                                                : getTime(lineHaul.lineHaulTime.gpsTime)}
                                        </TableCell>
                                        {displayDataForVolume(lineHaul)}
                                        { isUnloadingSequenceFlowEnabled
                                            ? <TableCell> {getUnloadingSequenceValue(lineHaul.unloadingSequence)} </TableCell>
                                            : null
                                        }
                                        <TableCell>
                                            <Link href={getFMCUrl(lineHaul)} type="secondary" target="_blank" rel="noreferrer noopener">
                                                View <Icon tokens={exportSmallTokens} />
                                            </Link>
                                        </TableCell>
                                    </TableRow>
                                )
                            )}
                        </Table>
                    </div>
                </div>
            </Row>
        </div>
    );
}

export default LineHauls


// WEBPACK FOOTER //
// ./src/components/linehaul/LineHauls.js